import script from "./EditorSmilesDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorSmilesDropdown.vue?vue&type=script&setup=true&lang=js"

import "./EditorSmilesDropdown.vue?vue&type=style&index=0&id=0c478280&lang=scss"

const __exports__ = script;

export default __exports__